export const CATEGORIES = ["Tutte", "Contratti", "Previdenza", "Contenzioso", "CCNL", "Sicurezza sul lavoro"];

export const fmtTime = (s) => {
  if (!s || isNaN(s)) return "0:00";
  const m = Math.floor(s / 60);
  const sec = Math.floor(s % 60);
  return `${m}:${sec.toString().padStart(2, "0")}`;
};

export const fmtDate = (iso) => {
  try {
    return new Date(iso).toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" });
  } catch { return ""; }
};
